import React from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import Label from './Label';

var YouSave = function YouSave(_ref) {
  var savedAmount = _ref.savedAmount,
      discount = _ref.discount,
      currency = _ref.currency;
  return discount && /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.youSave.label",
    values: {
      amount: /*#__PURE__*/React.createElement(FormattedNumber, {
        value: savedAmount,
        style: "currency" // eslint-disable-line react/style-prop-object
        ,
        currency: currency,
        minimumFractionDigits: 2
      }),
      discount: /*#__PURE__*/React.createElement(FormattedNumber, {
        value: discount,
        style: "percent" // eslint-disable-line react/style-prop-object
        ,
        maximumFractionDigits: 0
      })
    }
  }));
};

YouSave.defaultProps = {};
export default YouSave;